var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancelIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17510_12671)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_17510_12671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5869 4.08593L3.23766 19.4352L4.71424 20.9117L20.0635 5.5625L18.5869 4.08593Z",
    fill: "#A1ACB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0635 19.4375L4.71423 4.08826L3.23766 5.56483L18.5869 20.9141L20.0635 19.4375Z",
    fill: "#A1ACB7"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17510_12671"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(-1 0 0 1 24 0)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_17510_12671"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.7071,
    height: 21.7071,
    fill: "white",
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 27 12.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelIcon);
export default __webpack_public_path__ + "static/media/cancel-icon.37c8adc0237928f57bbb4bcd199c55cb.svg";
export { ForwardRef as ReactComponent };